import {
  AuthFlowComplete,
  AuthFlowId,
  AuthStepDefinition,
  AuthStepId,
  AuthStepRoute,
  AuthTransitionKey,
} from '../../models/auth-flow.models';

export const SELECT_ACCOUNT_STEP: AuthStepDefinition = {
  id: AuthStepId.SELECT_ACCOUNT,
  route: AuthStepRoute.Accounts,
  back: AuthStepId.CONFIRM_EMAIL,
  showLegalFooter: true,
  next: {
    [AuthFlowId.Login]: {
      [AuthTransitionKey.NeedTel]: AuthStepId.TEL_VERIFICATION,
      [AuthTransitionKey.Default]: AuthFlowComplete.Complete,
    },
  },
};
